import { ca } from '@cian/analytics';

export function trackPopupShow() {
  ca('eventSite', {
    name: 'oldevent',
    category: 'banner_callnow',
    action: 'show_widget',
    label: 'JK',
    useLastProducts: true,
  });
}

export function trackPopupClose() {
  ca('eventSite', {
    name: 'oldevent',
    category: 'banner_callnow',
    action: 'close',
    label: 'JK',
    useLastProducts: true,
  });
}
